module.exports = __webpack_public_path__ + "static/media/enabledPreviousIcon.9b8c1b08.svg";